import { Button, Container } from "@mui/material";
import styles from "./HomeInstitution.module.scss";
import { IconPack } from "Explore/Config/Icons";
import thumbnail from "Explore/Assets/homepage/homepage-institution.png";

const HomeInstitution = () => {
  return (
    <div className={styles["home-institution"]}>
      <Container
        maxWidth="lg"
        className={styles["home-institution__container"]}
      >
        <div className={styles["home-institution__left"]}>
          <p className={styles["home-institution__left--title"]}>
            Institutions
          </p>
          <p className={styles["home-institution__left--description"]}>
            Are you looking for a institution for your research projects? Follow
            us to find the right institutions for your goals!
          </p>
          <Button
            variant="contained"
            className={styles["home-institution__left--button"]}
            href="/explore/institution"
            endIcon={IconPack.arrow}
          >
            Browse Institutions
          </Button>
        </div>
        <div className={styles["home-institution__right"]}>
          <div className={styles["home-institution__right--image__container"]}>
            <img
              className={styles["home-institution__right--image"]}
              src={thumbnail}
              alt="thumbnail"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HomeInstitution;
